import React from "react";
import { Switch, Route } from "react-router-dom";
import { Header } from "./common/components/Header/header";
import { UserInfoProvider } from "./common/providers/user-info-provider";
import { AuthenticatedShell } from "./common/components/AuthenticatedShell/authenticated-shell";
import { PermissionGate } from "./common/components/PermissionGate/permission-gate";
import { OpsEmployeeGate } from "./common/components/OpsEmployeeGate/ops-employee-gate";
import { AppSkeleton } from "./common/components/AppSkeleton/app-skeleton";
import SessionExpired from "./pages/session-expired";
import CampaignsPage from "./pages/Campaigns/campaigns-page";
import { CampaignsSkeleton } from "./pages/Campaigns/campaigns-skeleton";
import HardwareDetailsPage from "./pages/HardwareDetails/hardware-details-page";
import SearchResultsHardwarePage from "./pages/HardwareSearch/hardware-search-page";
import OrdersPage from "./pages/Orders/orders-page";
import LcrOrderTrackingPage from "./pages/OrderTracking/Lcr/lcr-order-tracking-page";
import OrderConfirmationPage from "./pages/Confirmation/order-confirmation-page";
import CheckoutPage from "./pages/Checkout/checkout-page";
import MyHardwarePage from "./pages/MyHardware/my-hardware-page";
import ReplacementFlowPage from "./pages/Replacement/replacement-flow-page";
import NotFoundPage from "./pages/NotFound/not-found-page";
import { Paths } from "./common/paths/paths";
import { PERMISSIONS } from "./config";

const SHOP = [PERMISSIONS.USE_HARDWARE_SHOP];
const LCR = [PERMISSIONS.USE_LCR];
const SHOP_OR_LCR = [PERMISSIONS.USE_HARDWARE_SHOP, PERMISSIONS.USE_LCR];

const App: React.FC = () => {
  return (
    <Switch>
      <Route exact path={Paths.campaigns.url}>
        <AuthenticatedShell loadingSkeleton={<CampaignsSkeleton />}>
          <PermissionGate anyOfPermissions={[PERMISSIONS.USE_HARDWARE_BASELINE]}>
            <CampaignsPage />
          </PermissionGate>
        </AuthenticatedShell>
      </Route>

      <Route>
        <AuthenticatedShell loadingSkeleton={<AppSkeleton />}>
          <Header />
          <UserInfoProvider>
            <Switch>
              <Route exact path={Paths.sessionExpired.url}>
                <SessionExpired />
              </Route>
              <Route exact path={Paths.search.url}>
                <PermissionGate anyOfPermissions={SHOP}>
                  <SearchResultsHardwarePage />
                </PermissionGate>
              </Route>
              <Route exact path={Paths.orders.url}>
                <PermissionGate anyOfPermissions={SHOP_OR_LCR}>
                  <OrdersPage />
                </PermissionGate>
              </Route>
              <Route exact path={Paths.lcrOrderTracking.url}>
                <PermissionGate anyOfPermissions={LCR}>
                  <LcrOrderTrackingPage />
                </PermissionGate>
              </Route>
              <Route exact path={Paths.myHardware.url}>
                <PermissionGate anyOfPermissions={LCR}>
                  <OpsEmployeeGate>
                    <MyHardwarePage />
                  </OpsEmployeeGate>
                </PermissionGate>
              </Route>
              <Route exact path={Paths.replacement.url}>
                <PermissionGate anyOfPermissions={LCR}>
                  <OpsEmployeeGate>
                    <ReplacementFlowPage />
                  </OpsEmployeeGate>
                </PermissionGate>
              </Route>
              <Route exact path={Paths.detailsPage.url}>
                <PermissionGate anyOfPermissions={SHOP}>
                  <HardwareDetailsPage />
                </PermissionGate>
              </Route>
              <Route exact path={Paths.checkout.url}>
                <PermissionGate anyOfPermissions={SHOP}>
                  <CheckoutPage />
                </PermissionGate>
              </Route>
              <Route exact path={Paths.confirmation.url}>
                <PermissionGate anyOfPermissions={SHOP}>
                  <OrderConfirmationPage />
                </PermissionGate>
              </Route>
              <Route path={Paths.notFound.url}>
                <NotFoundPage />
              </Route>
            </Switch>
          </UserInfoProvider>
        </AuthenticatedShell>
      </Route>
    </Switch>
  );
};

export default App;
